module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.product) ? _c('div', {
    staticClass: "product-header",
    attrs: {
      "id": "impact-product-header"
    }
  }, [_c('h1', [_vm._v(_vm._s(_vm.heading || "Help Make an Impact"))]), _vm._v(" "), _c('p', {
    staticClass: "tagline"
  }, [_vm._v(_vm._s(_vm.product.meta.description))]), _vm._v(" "), _c('div', {
    staticClass: "goal-wrapper"
  }, [_c('div', {
    staticClass: "progress-bar"
  }, [_c('div', {
    staticClass: "progress-bar-wrapper"
  }, [_c('div', {
    staticClass: "progress-bar-inner",
    style: ({
      width: _vm.goalProgress + '%'
    })
  })])]), _vm._v(" "), _c('p', {
    staticClass: "goal"
  }, [_vm._v("\n      $" + _vm._s(_vm.formatCurrency(_vm.product.meta.currentDonationAmount)) + " of $" + _vm._s(_vm.formatCurrency(_vm.product.meta.goalAmount)) + "\n      raised\n    ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "deadline"
  }, [_vm._v(_vm._s(_vm.endDateText))])])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-21c11e58","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-webpack-plugin/loader.js?id=v6bwv9n4fgn!./~/string-replace-webpack-plugin/loader.js?id=oue8yteht5p!./src/components/impact-project/ImpactProjectHeader.vue
// module id = 652
// module chunks = 0